<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Kategori Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          to="/Settings/Categories"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth > 380">Kategoriler</span>
        </b-btn>

        <b-btn class="mr-3" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth > 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Category).length === 0">Hata!</b-alert>

    <b-alert
      show
      variant="info"
      v-if="Object.keys(Category).length > 0"
    >Düzenlenen Kategori: {{ CategoryOldName }}</b-alert>

    <form @submit.prevent="SaveCategory" v-if="Object.keys(Category).length > 0">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in CategoryGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Category[index]" @keypress.enter.prevent="SaveCategory"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Kategori Adı",
        Sort: "Sıralama"
      },
      CategoryOldName: "",
      Category: {},
      CategoryGUI: {}
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    }
  },
  methods: {
    async Refresh() {
      if (!this.StoreData.Categories) return;
      if (!this.StoreData.Categories[this.ParamID]) return;

      let _Category = Object.assign(
        {},
        this.StoreData.Categories[this.ParamID]
      );

      delete _Category.Products;

      await this.$set(this, "CategoryOldName", _Category.Name);
      await this.$set(this, "Category", _Category);
      await this.$set(
        this,
        "CategoryGUI",
        Object.filterKey(_Category, x => ["ID", "StoreID"].indexOf(x) === -1)
      );

      await this.$nextTick();
      await this.$forceUpdate();
    },
    async SaveCategory() {
      await this.$store.dispatch("AddLoading", "SaveCategory");

      await Services.Nozich.Send(
        "SaveCategory",
        {
          ID: this.ParamID,
          Category: this.Category
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SaveCategory");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Categories");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
